/**
 * <faq-accordion> - a list of independently-toggleable question/answer
 * panels.
 *
 * Each trigger is a real <button> (not a click handler on a <div>), so
 * Tab/Enter/Space work with zero extra wiring - this script only needs to
 * toggle state, not implement keyboard behavior from scratch. The smooth
 * expand/collapse itself is pure CSS (a grid-template-rows: 0fr -> 1fr
 * transition on the panel wrapper - see the .faq__answer-wrap rule in
 * faq.liquid), so this script's only job is flipping `is-open` and
 * keeping aria-expanded in sync for screen readers.
 *
 * Items open/close independently - opening one does not close the
 * others (not a single-open-at-a-time accordion).
 */
class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-faq-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggle(trigger));
    });
  }

  toggle(trigger) {
    const item = trigger.closest('[data-faq-item]');
    if (!item) return;
    const isOpen = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

customElements.define('faq-accordion', FaqAccordion);
